import { GADimension } from '@ps/web-core-enums';
import { mapValues } from 'lodash';
import ReactGA from 'react-ga';
import type { Primitive } from 'utility-types';

import type { TrackingContextValue } from '../providers/TrackingContext';

export const GAEvent = (
  params: Omit<Parameters<typeof ReactGA.event>[0], 'category'>,
  { category, widget }: TrackingContextValue,
  dimensions?: Record<string, Primitive | string[]>
) => {
  const allDimensions = { ...dimensions, [GADimension.WidgetName]: widget?.widgetName };
  ReactGA.set(allDimensions);
  ReactGA.event({ ...params, category });
  ReactGA.set(mapValues(allDimensions, () => null));
};
